export const pxPerKm = 25;
export const hourPerSecond = 0.2;

export const scaleSpeedVisual = 40;
